interface SEOMetaProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogImage?: string;
  ogType?: string;
  articlePublishedTime?: string;
  articleModifiedTime?: string;
}

export default function SEOMeta({
  title,
  description,
  keywords,
  canonicalUrl,
  ogImage,
  ogType = 'website',
  articlePublishedTime,
  articleModifiedTime,
}: SEOMetaProps) {
  const fullTitle = `${title} - 蜜桃视频在线`;
  const defaultImage = 'https://readdy.ai/api/search-image?query=modern%20video%20streaming%20platform%20with%20warm%20peach%20and%20amber%20tones%2C%20cinematic%20aesthetic%2C%20clean%20minimal%20design%2C%20soft%20lighting%2C%20elegant%20composition&width=1200&height=630&seq=mitao-og-default&orientation=landscape';

  const head = document.head;

  const setMeta = (selector: string, attr: string, value: string) => {
    let el = head.querySelector(selector) as HTMLMetaElement | null;
    if (!el) {
      el = document.createElement('meta');
      if (selector.startsWith('meta[property=')) {
        el.setAttribute('property', selector.match(/property="([^"]+)"/)?.[1] || '');
      } else if (selector.startsWith('meta[name=')) {
        el.setAttribute('name', selector.match(/name="([^"]+)"/)?.[1] || '');
      }
      head.appendChild(el);
    }
    el.setAttribute(attr, value);
  };

  const setLink = (selector: string, attr: string, value: string) => {
    let el = head.querySelector(selector) as HTMLLinkElement | null;
    if (!el) {
      el = document.createElement('link');
      if (selector.startsWith('link[rel=')) {
        el.setAttribute('rel', selector.match(/rel="([^"]+)"/)?.[1] || '');
      }
      head.appendChild(el);
    }
    el.setAttribute(attr, value);
  };

  document.title = fullTitle;
  setMeta('meta[name="description"]', 'content', description);
  setMeta('meta[name="keywords"]', 'content', keywords);
  setLink('link[rel="canonical"]', 'href', canonicalUrl);

  setMeta('meta[property="og:title"]', 'content', fullTitle);
  setMeta('meta[property="og:description"]', 'content', description);
  setMeta('meta[property="og:type"]', 'content', ogType);
  setMeta('meta[property="og:url"]', 'content', canonicalUrl);
  setMeta('meta[property="og:image"]', 'content', ogImage || defaultImage);
  setMeta('meta[property="og:site_name"]', 'content', '蜜桃视频在线');
  setMeta('meta[property="og:locale"]', 'content', 'zh_CN');

  setMeta('meta[name="twitter:card"]', 'content', 'summary_large_image');
  setMeta('meta[name="twitter:title"]', 'content', fullTitle);
  setMeta('meta[name="twitter:description"]', 'content', description);
  setMeta('meta[name="twitter:image"]', 'content', ogImage || defaultImage);

  if (articlePublishedTime) {
    setMeta('meta[property="article:published_time"]', 'content', articlePublishedTime);
  }
  if (articleModifiedTime) {
    setMeta('meta[property="article:modified_time"]', 'content', articleModifiedTime);
  }

  return null;
}